export default __webpack_public_path__ + "static/media/icon-dropdown.3abe788d.svg";